<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <v-row>
          <v-col
            cols="6"
          >

        <ValidationProvider
            rules="required"
            vid="schoolCodes"
            :name="$t('fields.code').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="codes"
            v-model="form.school_code_id"
            item-text="name"
            item-value="id"
            :label="$t('fields.code')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="branchCode"
            :name="$t('fields.branch_code').toLowerCase()"
            v-slot="{ errors }"
        >
         <v-text-field
            v-model=" form.branch_code"
            :counter="5"
            :label="$t('fields.branch_code')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="email"
            :name="$t('fields.email').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.email"
            :counter="150"
            :label="$t('fields.email')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            vid="propagandist"
            :name="$t('fields.propagandist').toLowerCase()"
            v-slot="{ errors }"
        >
          <PropagandistSelect
            v-model="form.propagandist_id"
            :errors="errors"
          >
          </PropagandistSelect>
        </ValidationProvider>

        <v-row>
          <v-col
            cols="6"
          >
            <ValidationProvider
                vid="email_2"
                :name="$t('fields.email_additional').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.email_2"
                :counter="150"
                :label="$t('fields.email_additional')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="6"
          >
            <ValidationProvider
                vid="email_3"
                :name="$t('fields.email_additional').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.email_3"
                :counter="150"
                :label="$t('fields.email_additional')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
        <ValidationProvider
            rules="required"
            vid="phone"
            :name="$t('fields.phone').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.phone"
            :counter="30"
            :label="$t('fields.phone')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <v-row>
          <v-col
            cols="6"
          >
          <ValidationProvider
                vid="phone_2"
                :name="$t('fields.phone_additional').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.phone_2"
                :counter="30"
                :label="$t('fields.phone_additional')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="6"
          >
            <ValidationProvider
                vid="phone_3"
                :name="$t('fields.phone_additional').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.phone_3"
                :counter="30"
                :label="$t('fields.phone_additional')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>

          <v-row>
            <v-col
               cols="12"
            >


          <v-row
            v-if="schoolType.options && schoolType.options.is_elementary"
          >
            <v-col
               cols="12"
            >
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('fields.elementary_school') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-text-field
                      v-for="(item, index) in 5"
                      :key="item"
                      v-model="form.elementary_classes[index]"
                      :label="$t('fields.class')"
                    >
                    <span slot="prepend">{{ (index + 1) }}</span>
                    </v-text-field>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            </v-col>
          </v-row>

          <v-row
            v-if="schoolType.options && schoolType.options.is_primary"
          >
            <v-col
               cols="12"
            >
              <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('fields.primary_school') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-text-field
                      v-for="(item, index) in 3"
                      :key="item"
                      v-model="form.primary_classes[index]"
                      :label="$t('fields.class')"
                    >
                    <span slot="prepend">{{ (index + 1) }}</span>
                    </v-text-field>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            </v-col>
          </v-row>

          <v-row
            v-if="schoolType.options && schoolType.options.is_secondary"
          >
            <v-col
              cols="12"
            >
              <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('fields.secondary_school') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-text-field
                      v-for="(item, index) in 5"
                      :key="item"
                      v-model="form.secondary_classes[index]"
                      :label="$t('fields.class')"
                    >
                    <span slot="prepend">{{ (index + 1) }}</span>
                    </v-text-field>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            </v-col>
          </v-row>
            </v-col>
          </v-row>
        </v-row>
          </v-col>
          <v-col
            cols="6"
          >
            <ValidationProvider
            rules="required"
            vid="region"
            :name="$t('fields.region').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="regions"
            v-model="form.region"
            @change="fetchProvinces(); resetCities(); resetZipCodes();"
            item-text="name"
            item-value="id"
            attach
            chips
            :label="$t('fields.region')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>
         <ValidationProvider
            rules="required"
            vid="province"
            :name="$t('fields.province').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="provinces"
            v-model="form.province"
            @change="fetchCities(); resetZipCodes();"
            item-text="name"
            item-value="id"
            attach
            chips
            :label="$t('fields.province')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="city"
            :name="$t('fields.city').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-select
            :items="cities"
            v-model="form.city"
            @change="fetchZipCodes()"
            item-text="name"
            item-value="id"
            attach
            chips
            :label="$t('fields.city')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>
        
        <ValidationProvider
            rules="required"
            vid="address"
            :name="$t('fields.address').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.address"
            :label="$t('fields.address')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="zipcode"
            :name="$t('fields.zipcode').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-select
            :items="zipcodes"
            v-model="form.zipcode"
            item-text="postalcode"
            item-value="id"
            attach
            chips
            :label="$t('fields.zipcode')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>

          <v-menu
            ref="menu_entry"
            v-model="form.menu_entry"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="form.entry_time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.entry_time"
                :label="$t('fields.entry_time')"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="form.menu_entry"
              v-model="form.entry_time"
              full-width
              @click:minute="$refs.menu_entry.save(form.entry_time)"
            ></v-time-picker>
          </v-menu>

          <v-menu
            ref="menu_ricreation"
            v-model="form.menu_ricreation"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="form.ricreation_time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.ricreation_time"
                :label="$t('fields.ricreation_time')"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="form.menu_ricreation"
              v-model="form.ricreation_time"
              full-width
              @click:minute="$refs.menu_ricreation.save(form.ricreation_time)"
            ></v-time-picker>
          </v-menu>

          <v-menu
            ref="menu_ricreation_2"
            v-model="form.menu_ricreation_2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="form.ricreation_time_2"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.ricreation_time_2"
                :label="$t('fields.ricreation_time_2')"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="form.menu_ricreation_2"
              v-model="form.ricreation_time_2"
              full-width
              @click:minute="$refs.menu_ricreation_2.save(form.ricreation_time_2)"
            ></v-time-picker>
          </v-menu>

          <v-text-field
            v-model=" form.website"
            :label="$t('fields.website')"
          ></v-text-field>

          <v-text-field
            v-model=" form.note"
            :label="$t('fields.note')"
          ></v-text-field>
          </v-col>
        </v-row>


    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsService } from '../../../utils/services/schools.service';
  import { schoolsTypesService } from '../../../utils/services/schoolsTypes.service';
  import { schoolsLocationsService } from '../../../utils/services/schoolsLocations.service';
  import { citiesService } from '../../../utils/services/cities.service';
  import { schoolsCodesService } from '../../../utils/services/schoolsCodes.service';

  import PropagandistSelect from '../../shared/Vselects/PropagandistSelect.vue';

  export default {
    name: 'SchoolLocationModal',
    components: { PropagandistSelect },
    data() {
      return {
        stored: null,
        regions: [],
        provinces: [],
        cities: [],
        zipcodes: [],
        codes: [],
        propagandists: [],
        school: {},
        schoolType: {},
        schoolLocation: {},
        form: {
          branch_code: null,
          propagandist_id: null,
          school_id: null,
          school_code_id: null,
          region: null,
          province: null,
          city: null,
          address: null,
          code: null,
          phone: null,
          phone_2: null,
          phone_3: null,
          email: null,
          email_2: null,
          email_3: null,
          zipcode: null,
          website: null,
          note: null,

          entry_time: null,
          menu_entry: false,

          ricreation_time: null,
          menu_ricreation: false,

          ricreation_time_2: null,
          menu_ricreation_2: false,

          primary_classes: {},
          secondary_classes: {},
          elementary_classes: {},
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      isValidTime(value) {
        if (!value) return false;
        // accetta formati tipo "HH:mm"
        return /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
      },

      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },

      fetchCodes() {
        return schoolsCodesService.index(this.form.school_id)
        .then(response => {
            this.codes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      resetProvinces() {
        this.provinces = [];
      },
      resetCities() {
        this.cities = [];
      },
      resetZipCodes() {
        this.zipcodes = [];
      },
      fetchRegions() {
        return citiesService.getRegions({
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.regions = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchProvinces() {
        return citiesService.getProvinces(this.form.region,
        {
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.provinces = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchCities() {
        return citiesService.getCities(this.form.region, this.form.province,
        {
          filters: {
            sortBy: ['name'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.cities = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchZipCodes() {
        return citiesService.getZipCodes(this.form.region, this.form.province, this.form.city,
        {
          filters: {
            sortBy: ['postalcode'],
            sortDesc: [true],
          },
        })
        .then(response => {
            this.zipcodes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchSchoolLocation() {
        return schoolsLocationsService.get(this.data.stored.school_id, this.data.stored.id)
        .then(response => {
            this.schoolLocation = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchSchool() {
        return schoolsService.get(this.data.stored.school_id)
        .then(response => {
            this.school = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchSchoolType() {
        return schoolsTypesService.get(this.school.school_type_id)
        .then(response => {
            this.schoolType = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      await this.fetchRegions();
      if (this.data.stored) {
        this.form.school_id = this.data.stored.school_id;
        await this.fetchSchool();
        await this.fetchSchoolType();
        await this.fetchCodes();
        if (this.data.stored.id) {
          await this.fetchSchoolLocation();
          // set data
          this.form.id = this.data.stored.id;
          this.form.school_code_id = this.schoolLocation.school_code_id;
          this.form.region = this.schoolLocation.region_id;
          this.form.province = this.schoolLocation.province_id;
          this.form.city = this.schoolLocation.city_id;
          this.form.address = this.schoolLocation.street;
          this.form.phone = this.schoolLocation.phone;
          this.form.email = this.schoolLocation.email;
          this.form.zipcode = this.schoolLocation.postal_code_id;
          this.form.propagandist_id = this.schoolLocation.propagandist_id;

          this.form.phone_2 = this.schoolLocation.options.phone_2;
          this.form.phone_3 = this.schoolLocation.options.phone_3;
          this.form.email_2 = this.schoolLocation.options.email_2;
          this.form.email_3 = this.schoolLocation.options.email_3;
          
           this.form.entry_time = this.isValidTime(this.schoolLocation.options.entry_time)
            ? this.schoolLocation.options.entry_time
            : null;

          this.form.ricreation_time = this.isValidTime(this.schoolLocation.options.ricreation_time)
            ? this.schoolLocation.options.ricreation_time
            : null;

          this.form.ricreation_time_2 = this.isValidTime(this.schoolLocation.options.ricreation_time_2)
            ? this.schoolLocation.options.ricreation_time_2
            : null;

          if (this.schoolLocation.options.primary_classes) {
            this.form.primary_classes = this.schoolLocation.options.primary_classes;
          }
          if (this.schoolLocation.options.secondary_classes) {
            this.form.secondary_classes = this.schoolLocation.options.secondary_classes;
          }
          if (this.schoolLocation.options.elementary_classes) {
            this.form.elementary_classes = this.schoolLocation.options.elementary_classes;
          }
          this.form.website = this.schoolLocation.options.website;
          this.form.note = this.schoolLocation.options.note;
          this.form.branch_code = this.schoolLocation.options.branch_code;
          console.log(this.schoolLocation);
          await this.fetchProvinces();
          await this.fetchCities();
          await this.fetchZipCodes();
        }
      }
      this.loadingModal(false);
    },
  };
</script>
